import { useCallback, useRef } from 'react';

import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';
import { centralizedClipIdSelector } from '~/store/centralizedClip/selectors';
import { useAirStore } from '~/utils/ReduxUtils';

export const useIgnoreSelectionDeleteShortcut = () => {
  const store = useAirStore();

  const ignoreSelectionDeleteShortcut = useCallback(() => {
    if (useWorkspaceRightPanelStore.getState().selectedCanvasId) {
      return true;
    }
    if (centralizedClipIdSelector(store.getState())) {
      return true;
    }

    return false;
  }, [store]);

  const ignoreSelectionDeleteShortcutRef = useRef(ignoreSelectionDeleteShortcut);
  ignoreSelectionDeleteShortcutRef.current = ignoreSelectionDeleteShortcut;

  return { ignoreSelectionDeleteShortcutRef };
};
